// extracted by mini-css-extract-plugin
export default {"pageContainer":"Dashboard_pageContainer__Ptk-H","container":"Dashboard_container__pELXh"};